export const DIARY_SHARED_SUBTAB_MAIN = 'diary-shared-subtab-main';
export const DIARY_SHARED_SUBTAB_CLAIM = 'diary-shared-subtab-claim';
export const DIARY_SEARCH_STATE_MAIN = 'diary-search-state-main';
export const DIARY_SEARCH_STATE_CLAIM = 'diary-search-state-claim';

export const DIARY_PREF_TYPE = 'SHARED_DIARY';
export const DIARY_PREF_PERIOD_MAIN = 'MY_DIARIES_PERIOD_MAIN';
export const DIARY_PREF_PERIOD_CLAIM = 'MY_DIARIES_PERIOD_CLAIM';
export const DIARY_PREF_ALLOW_STATUS_UPDATE = 'ALLOW_STATUS_UPDATE';

/** Classic JURIS diary email notify preference (VIAONE.PREFERENCES). */
export const DIARY_JURIS_NOTIFY_TYPE = 'CLIENT_DIARY_EMAIL';
export const DIARY_JURIS_NOTIFY_KEY = 'DEFAULT';

export type DiaryYesNoPreference = 'Y' | 'N';

export interface DiaryPreferenceValue {
  key?: string;
  value?: string;
}

/** Normalize persisted preference values before using them as form defaults. */
export function normalizeDiaryYesNoPreference(
  value: unknown,
  fallback: DiaryYesNoPreference,
): DiaryYesNoPreference {
  const normalized = String(value ?? '')
    .trim()
    .toUpperCase();
  return normalized === 'Y' || normalized === 'N' ? normalized : fallback;
}

/** Read the requested preference defensively in case the API returns multiple rows. */
export function readDiaryYesNoPreference(
  preferences: DiaryPreferenceValue[] | null | undefined,
  key: string,
  fallback: DiaryYesNoPreference,
): DiaryYesNoPreference {
  const preference =
    preferences?.find(
      (item) => item.key?.trim().toUpperCase() === key.toUpperCase(),
    ) ?? preferences?.[0];
  return normalizeDiaryYesNoPreference(preference?.value, fallback);
}

export type DiarySharedSubTab = 'my-diaries' | 'search';
export type DiaryPeriodMode = 'week' | 'three-month' | 'all';

export interface DiarySearchSessionState {
  request: unknown;
  results: unknown[];
  performed: boolean;
}
